<script setup lang="ts">
import { KollegeExpenseRecordDailyLessonInputState } from '@/types/schema.generated'
import { computed, useCssModule } from 'vue'
import type { DailyLessonStatusKollegeExpenseRecordDailyLessonInputFragment } from './DailyLessonStatus.generated'

const props = defineProps<{
  dailyLessonInput: DailyLessonStatusKollegeExpenseRecordDailyLessonInputFragment
}>()

const classes = useCssModule()

const status = computed((): [label: string, className: string] => {
  switch (props.dailyLessonInput.state) {
    case KollegeExpenseRecordDailyLessonInputState.NotInput:
      return ['未記入', classes['icon--notFilled']]
    case KollegeExpenseRecordDailyLessonInputState.Draft:
      return ['記入途中', classes['icon--draft']]
    case KollegeExpenseRecordDailyLessonInputState.Filled:
      return ['記入済み', classes['icon--filled']]
    default:
      return ['未記入', classes['icon--notFilled']]
  }
})
</script>
<template>
  <div :class="$style.wrapper">
    <span :class="[$style.icon, status[1]]">●</span>
    <span :class="$style.text">{{ status[0] }}</span>
  </div>
</template>
<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  font-size: 12px;
  line-height: 1;
}

.icon--notFilled {
  color: $color-surface-accent-red;
}

.icon--draft {
  color: $color-surface-accent-yellow;
}

.icon--filled {
  color: $color-surface-accent-green;
}

.text {
  font-size: 12px;
  line-height: 1;
}
</style>
